import React from "react";
import { repositories } from "src/externals";
import { useBehaviour } from "./useBehaviour";
import { View } from "./view";

export const Pattern = () => {
  return (
    <View {...useBehaviour({ sources: repositories })} />
  );
};